import {Component} from 'react'
import PropTypes from 'prop-types'

import './Results.scss'

export default class ResultsOffers extends Component {
  static defaultProps = {
    nb: 0,
    className: ''
  }

  static propTypes = {
    nb: PropTypes.number,
    className: PropTypes.string
  }

  render() {
    return (
      <div className="results">
        <div className="nb text-center">{`${this.props.nb} annonce(s)`}</div>
      </div>
    )
  }
}
